// Strips out `undefined`, `null`, `[]`, `""`, and `NaN`, but keeps `0` and `false`.

export function removeNullish(obj: object) {
  const result: Record<string, any> = {}

  for (const [key, value] of Object.entries(obj)) {
    // Note the double equal `==`, this will catch `null` and `undefined`
    if (value == null) continue
    // Catches `""`, `[]`
    if (value.length === 0) continue
    // Catches `NaN`
    if (typeof value === 'number' && isNaN(value)) continue

    result[key] = value
  }

  return result
}
